import React, { useState, useEffect } from 'react';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';
import { InputNumber } from 'primereact/inputnumber';
 import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
       

export default function ShowMyWalletTransactions(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [wallet, setWallet] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setLoading(true);
        var params = {
            login:util.getLoginDto(), 
        };
        var url = config.Server+`/payment/wallet/get`;
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response); 
                var cs = 0;
                var ds = 0;
                for(var i=0;i<response.transactions.length;i++){
                    ds += response.transactions[i].increase;
                    cs += response.transactions[i].decrease;
                    if(ds > cs){
                        var rem = ds - cs;
                        response.transactions[i]["remain"] = util.toPersianDigits(util.SeperatePrice(rem));
                    }
                    else if(cs > ds){
                        var rem = cs - ds;
                        response.transactions[i]["remain"] = util.toPersianDigits(util.SeperatePrice(rem)) + "منفی";
                    }
                    else{
                        var rem = 0;
                        response.transactions[i]["remain"] = util.toPersianDigits(util.SeperatePrice(rem));
                    }
                }
                setWallet(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });
    }, []);
    
    const onBackButtonClick = function(){
        setRedirectUrl("/my-wallet/get");
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت تراکنش ها..." />
                </Col>
            </Row>
        </>
        :
        <>
            <div style={{textAlign:"center", padding:"10px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px", fontWeight:"bold"}}>
                <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{onBackButtonClick()}} style={{width:"48px", height:"32px", position:"absolute", top:"15px", right:"20px", cursor:"pointer"}} />
                لیست تراکنش های کیف پول
            </div>

              <DataTable value={wallet.transactions} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id">
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="transactionDate" header={"تاریخ"} body={(row, options) => util.toPersianDigits(util.SeperateDate(row.transactionDate))} sortable className="list-cell-text-align"></Column>
                <Column field="transactionTime" header={"زمان"} body={(row, options) => util.toPersianDigits(util.SeperateTime(row.transactionTime))} sortable className="list-cell-text-align"></Column>
                <Column field="comment" header={"شرح"} sortable className="list-cell-text-align"></Column>
                <Column field="increase" body={(row) => (util.toPersianDigits(util.SeperatePrice(row.increase)) )} header={"افزایش"} sortable className="list-cell-text-align"></Column>
                <Column field="decrease" body={(row) => (util.toPersianDigits(util.SeperatePrice(row.decrease)) )} header={"کاهش"} sortable className="list-cell-text-align"></Column>
                <Column field="remain" body={(row) => (util.toPersianDigits(util.SeperatePrice(row.remain)) )} header={"مانده"} sortable className="list-cell-text-align"></Column>
              </DataTable>

            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}